import { render, staticRenderFns } from "./addPartner.vue?vue&type=template&id=833c1742"
import script from "./addPartner.vue?vue&type=script&lang=js"
export * from "./addPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports